import Link from "next/link";
import { Container, Row, Col } from "react-bootstrap";
import { connect } from "react-redux";
import { setLoader } from "../../redux/actions/globalAction";
// import { spring, useCurrentFrame, useVideoConfig } from "remotion";

const MobileMechanic = ({ globalData, setLoader }) => {
  return (
    <div style={{ paddingLeft: "3%", paddingRight: "3%" }} id="mechanic">
      <Container>
        <Row style={{ display: "flex", alignItems: "center" }}>
          <Col
            lg={3}
            className="mobile-mechanice-main-title"
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Row className="mobile-mechanice-title">
              <Col
                className="mobile-mechanice-title"
                style={{ paddingRight: "70px" }}
              >
                <h2>Mobile Mechanic</h2>
                <p className="subHead-all text-center for-mobile">
                  Let Our Crew Reach Your Location For Selected Periodic
                  Services
                </p>
                <img
                  alt="mobile-mechanice-img"
                  src="/assets/mechanic/text.svg"
                  className="mobile-mechanice-img"
                />
                <Link
                  href={`/services/${
                    globalData.locationData?.data?.EmirateAreaSlug || "dubai"
                  }/mobile-mechanic`}
                >
                  <a
                    onClick={() => {
                      localStorage.setItem(
                        "selected-service",
                        "mobile-mechanic"
                      );

                      setLoader(true);
                    }}
                  >
                    <button
                      className="otp-button req-btn mt-5"
                      style={{
                        background: "#F58B1F",
                        paddingLeft: "35px",
                        paddingRight: "35px",
                        // height: 'auto',
                        borderRadius: 50,
                      }}
                    >
                      REQUEST NOW
                    </button>
                  </a>
                </Link>
              </Col>
            </Row>
          </Col>
          <Col lg={9}>
            <img
              alt="mobile-mechanice-img"
              src="/assets/mechanic/person.svg"
              width="12%"
              style={{
                display: "flex",
                position: "absolute",
                bottom: 0,
                zIndex: 8,
              }}
            />
            <img
              alt="mobile-mechanice-img"
              src="/assets/mechanic/background.svg"
              width="100%"
            />
            <img
              alt="mobile-mechanice-img"
              src="/assets/mechanic/van.webp"
              width="85%"
              style={{
                display: "flex",
                position: "absolute",
                bottom: 0,
                zIndex: 6,
                left: "12%",
              }}
            />
            <img
              alt="mobile-mechanice-img"
              src="/assets/mechanic/phone.svg"
              width={"160px"}
              className="hide-in-mobile"
              style={{
                display: "flex",
                position: "absolute",
                bottom: 6,
                right: "10%",
                zIndex: 7,
              }}
            />
            <img
              alt="mobile-mechanice-img"
              src="/assets/mechanic/icons.svg"
              width={"135px"}
              className="hide-in-mobile"
              style={{
                display: "flex",
                position: "absolute",
                bottom: 15,
                right: "11%",
                zIndex: 8,
              }}
            />
          </Col>
        </Row>
        <Row
          className="mobile-mechanice-description"
          style={{ padding: "25px" }}
        >
          <Col lg={12}>
            <div
              style={{
                textAlign: "center",
                fontSize: "16px",
                fontWeight: "400",
                color: "#c2c2c2",
              }}
            >
              <span className="one-line">Pre-Purchase Inspection</span> |{" "}
              <span className="one-line">Car-Health Check</span> |{" "}
              <span className="one-line">Car Wash</span> |{" "}
              <span className="one-line">Car Wash + Disinfection</span> |{" "}
              <span className="one-line">AC Service</span> |{" "}
              <span className="one-line">10k Oil Change service</span> |{" "}
              <span className="one-line">New Tyre Replacement</span> |{" "}
              <span className="one-line">Wheel Balancing</span> |{" "}
              <span className="one-line">Battery Boost</span> |{" "}
              <span className="one-line">Flat Tyre</span> |
              <span className="one-line"> Lockout</span> |{" "}
              <span className="one-line">Refueling</span> |{" "}
              <span className="one-line">Flat Bed Recovery </span>
            </div>
          </Col>
        </Row>
        <Row className="p-2">
          <Col
            lg={12}
            md={12}
            sm={12}
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              // padding: "25px",
            }}
          >
            <Link
              href={`/services/${
                globalData.locationData?.data?.EmirateAreaSlug || "dubai"
              }/mobile-mechanic`}
            >
              <a
                onClick={() => {
                  localStorage.setItem("selected-service", "mobile-mechanic");
                  setLoader(true);
                }}
              >
                <button
                  className="otp-button req-btn-mob mb-2"
                  style={{
                    background: "#F58B1F",
                    paddingLeft: "35px",
                    paddingRight: "35px",
                    // height: 'auto',
                    borderRadius: 50,
                  }}
                >
                  REQUEST NOW
                </button>
              </a>
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    apiData: state.apiData,
    globalData: state.globalData,
    profile: state.profile,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    setLoader: (flag) => {
      dispatch(setLoader(flag));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MobileMechanic);
